import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useChatUi } from '../../context/ChatUiContext';

interface Props {
  productId: string | number;
  disabled?: boolean;
}

const CatalogChatMenu: React.FC<Props> = ({ productId, disabled }) => {
  const { openModal } = useChatUi();
  if (productId == null || productId === '' || disabled) return null;
  const id = String(productId);
  const href = `${typeof window !== 'undefined' ? window.location.origin : ''}/chat?productId=${encodeURIComponent(id)}`;

  return (
    <Dropdown onClick={(e) => e.stopPropagation()} align="end">
      <Dropdown.Toggle
        variant="link"
        size="sm"
        className="p-0 text-muted text-decoration-none"
        id={`chat-menu-${id}`}
        title="Chat"
      >
        💬
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onMouseDown={(e) => {
            e.preventDefault();
            openModal(id);
          }}
        >
          Открыть здесь
        </Dropdown.Item>
        <Dropdown.Item as="a" href={href} target="_blank" rel="noopener noreferrer">
          Открыть в новой вкладке
        </Dropdown.Item>
        <Dropdown.Item
          as="a"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault();
            window.open(href, '_blank', 'noopener,noreferrer,width=1100,height=700');
          }}
        >
          Открыть в новом окне
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CatalogChatMenu;
